import { useEffect, useState } from 'react';
import { Modal, Input, Switch, message } from 'antd';
import * as claus from 'src/_shared/services/claus/endpoints';

export default function WebhookFormDialog({ orgId, integrationId, open, webhook, defaultName, onClose, onSaved }) {
	const isEdit = !!webhook;
	const [name, setName] = useState('');
	const [endpoint, setEndpoint] = useState('');
	const [enabled, setEnabled] = useState(true);
	const [saving, setSaving] = useState(false);

	useEffect(() => {
		if (!open) return;
		setName(webhook?.name || defaultName || '');
		setEndpoint(webhook?.endpoint || '');
		setEnabled(webhook ? !!webhook.enabled : true);
	}, [open, webhook, defaultName]);

	async function save() {
		if (!name.trim() || !endpoint.trim()) {
			message.error('Name and endpoint URL are required.');
			return;
		}
		setSaving(true);
		try {
			if (isEdit) {
				await claus.patchWebhook(orgId, integrationId, webhook.id, { name, endpoint, enabled });
			} else {
				await claus.createWebhook(orgId, integrationId, { name, endpoint, enabled });
			}
			message.success('Webhook saved');
			await onSaved();
		} catch (e) {
			message.error(e.message || 'Could not save the webhook.');
		} finally {
			setSaving(false);
		}
	}

	return (
		<Modal
			title={isEdit ? 'Edit webhook' : 'Add webhook'}
			open={open}
			onCancel={onClose}
			onOk={save}
			okText="Save"
			confirmLoading={saving}
			wrapClassName="erin-integrations"
		>
			<div className="ei-field">
				<label className="ei-field-label">Name</label>
				<Input value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. process-jobs (job sync)" />
			</div>
			<div className="ei-field">
				<label className="ei-field-label">Endpoint URL</label>
				<Input
					value={endpoint}
					onChange={(e) => setEndpoint(e.target.value)}
					placeholder="https://…/jobs/{token}"
				/>
				<span className="ei-field-hint">
					For the job-sync webhook, paste the URL from the integration-engine stack output (it embeds a secret token).
				</span>
			</div>
			<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
				<Switch checked={enabled} onChange={setEnabled} /> <span className="js-muted">Enabled</span>
			</div>
		</Modal>
	);
}
